import {Grid, IconButton} from '@material-ui/core';
import React from 'react';
import {Link} from 'react-router-dom';
import Icon from '@mdi/react';
import {mdiPrinter, mdiFileExcelOutline} from '@mdi/js';
import List from './response3plList';
import ExcelExport from './excelExport';

export function Response3PL(props: any) {
  return (
    <Grid container spacing={3}>
      <Grid
        style={{margin: 0}}
        spacing={5}
        container
        alignItems={'center'}
        justify={'space-between'}
      >
        <Grid item>
          {props.data.length} {'سفارش'}
        </Grid>
        <Grid item>
          {props.data&&(
            <ExcelExport
            data={props.data}
            />
          )
          }
          <IconButton
            onClick={() => {
              const win = window.open(
                `/3pl-print-labels/${props.data[0].orderId}`,
                '_blank'
              )!;
            }}
            style={{
              border: '2px solid ',
              marginLeft: '5px',
              borderRadius: '5px',
            }}
          >
            <Icon path={mdiPrinter} size={1} color={'primary'} />
          </IconButton>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <List data={props.data} />
      </Grid>
    </Grid>
  );
}
